var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4352 3H7.55556C5.59355 3 4 4.60276 4 6.55556V19.5343C4 21.1923 5.18826 21.8923 6.64364 21.091L11.1387 18.5947C11.6177 18.3276 12.3915 18.3276 12.8613 18.5947L17.3564 21.091C18.8117 21.9016 20 21.2015 20 19.5343V6.55556C19.9908 4.60276 18.3972 3 16.4352 3ZM14.2982 11.6586H12.6862V13.3258C12.6862 13.7035 12.3731 14.0167 11.9954 14.0167C11.6177 14.0167 11.3045 13.7035 11.3045 13.3258V11.6586H9.69257C9.31491 11.6586 9.00173 11.3454 9.00173 10.9678C9.00173 10.5901 9.31491 10.2769 9.69257 10.2769H11.3045V8.72021C11.3045 8.34254 11.6177 8.02936 11.9954 8.02936C12.3731 8.02936 12.6862 8.34254 12.6862 8.72021V10.2769H14.2982C14.6759 10.2769 14.9891 10.5901 14.9891 10.9678C14.9891 11.3454 14.6759 11.6586 14.2982 11.6586Z",
    fill: "#0082CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.19b14b19e7b715e406763d4321a61437.svg";
export { ForwardRef as ReactComponent };